import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import { grayScale, swc } from "@teamsparta/design-system";
import {
  MobileBody2,
  MobileCaption1,
  MobileTitle1,
  WebBody2,
  WebTitle1,
} from "@/system/day/font/font";

export const Wrapper = styled.section`
  position: relative;
  display: grid;
  gap: 60px;
  flex-direction: column;
  margin: 0 auto;
  width: 360px;
  padding: 0 15px;
  ${DESKTOP} {
    margin: 60px auto 0;
    width: 935px;
    padding: 0 7px;
  }
`;

export const Solution = styled.div`
  z-index: 10;
  ${DESKTOP} {
    width: 421px;
    padding: 0 16px;
    margin-left: auto;
  }
`;
export const Divider = styled.div`
  border-left: 2px solid ${grayScale.gray10};
  position: absolute;
  height: 1340px;
  left: 26px;
  ${DESKTOP} {
    left: initial;
    height: 1540px;
    right: 396px;
  }
`;
export const Step = styled.div`
  display: flex;
`;

export const Number = styled.div<{ intersecting: boolean }>`
  ${MobileCaption1};
  color: ${(props) =>
    props.intersecting ? "white !important" : `${grayScale.gray80} !important`};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  width: 24px;
  height: 24px;
  background-color: ${(props) =>
    props.intersecting
      ? `${swc.blue} !important`
      : `${grayScale.gray10} !important`};
  ${DESKTOP} {
    ${WebBody2};
    width: 30px;
    height: 30px;
    margin-bottom: 10px;
  }
`;

export const Title = styled.h2`
  ${MobileTitle1};
  padding-left: 10px;
  ${DESKTOP} {
    ${WebTitle1};
    padding-left: 19px;
  }
`;

export const DesktopImage = styled.div`
  display: none;
  ${DESKTOP} {
    display: flex;
    justify-content: right;
    margin: 30px 0 0 50px;
    width: 339px;
    height: 162px;
  }
`;

export const MobileImage = styled.div`
  display: flex;
  padding: 20px 0 0 30px;
  ${DESKTOP} {
    display: none;
  }
`;

export const Desc = styled.div`
  ${MobileBody2};
  color: ${grayScale.gray80} !important;
  padding: 20px 0 0 30px;
  ${DESKTOP} {
    width: 339px;
    display: flex;
    padding: 20px 0 0;
    ${WebBody2};
    margin-left: auto;
  }
`;
